import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox'
import CloseIcon from '@material-ui/icons/Close'
import ChangePasswordDialog from '../ChangePasswordDialog/ChangePasswordDialogContainer'

export default class UserProfile extends Component {

  state = { open: false }

  logout() {
    if (window.confirm('Are you sure you wish to logout?')) 
      this.props.logout()
  }

  closeProfile() { this.props.closeProfile() }

  handleClickOpen = () => { this.setState({ open: true }) }

  handleClose = () => { this.setState({ open: false }) }

  render() {
    let { user: { birthday, username } = {}, name } = this.props
    return (
      <Container>
        <CloseProfile onClick={this.closeProfile.bind(this)} />
        <SideBar w={364}>
          <Username>{name}</Username>
          <Action>Profile</Action>
          <Links>
            <Link target='_blank' href='https://healthera.co.uk/'>Legal</Link>
            <Link target='_blank' href='https://www.healthera.co.uk/pharmacy-terms'>Terms & Conditions</Link>
            <Link onClick={this.logout.bind(this)}> Logout</Link>
          </Links>
        </SideBar>
          <Content auto>
            <Fragment>
              <Header>Profile</Header>
              <Subheader>Personal Information</Subheader>
              <Info><span>Name:</span>{name}</Info>
              <Info><span>Date of Birth:</span><Birthdate dob={birthday} /></Info>
              <Subheader border>Account information</Subheader>
              <Info><span>Email Address:</span>{username}</Info>
              <Info><span>Password:</span>●●●●●●●●●</Info>
              <Info cursor={`pointer`} color={`#2f9d6d`} fontweight={`bold`} onClick={this.handleClickOpen.bind(this)}>Change Password</Info>
              <ChangePasswordDialog 
                  open={this.state.open}
                  onClose={this.handleClose.bind(this)}
                />
            </Fragment>
        </Content>
      </Container >
    )
  }
}

const Birthdate = (props) => {
  let { dob } = props
  dob = new Date(dob * 1000)
  return dob.toLocaleDateString()
}

// Styled Components
const CloseProfile = styled(CloseIcon)`
&&
{
  font-size: 35px;
  position: absolute;
  right: 28px;
  top: 28px;
  z-index: 3;
  cursor: pointer;
}
`
const Container = styled(Flex)`
&&
{
  min-height: 100vh;
  width: 100vw;
  position: relative;
}
`
const Content = styled(Box)`
&&
{
  font-size: 13px;
  color: #ffffff;
  line-height: 59px;
  background: #fff;
  margin: 0;
  padding:0 24px;
}
`
const SideBar = styled(Box)`
&&
{
  font-size: 13px;
  color: #ffffff;
  line-height: 59px;
  background: #2f9d6d;
  margin: 0;
  padding: 0 24px;
  position: relative;
  z-index: 1;
  min-height: 100%;
}
`
const Header = styled.p`
&&
{
  font-size: 22px;
  font-weight: 800;
  color: #2f9d6d;
  text-transform: uppercase;
  border-bottom: 1px solid #efefef;
  padding-bottom: 12px;
}
`
const Subheader = styled.p`
&&
{
  font-size: 18px;
  font-weight: 800;
  color: #282828;
  text-transform:uppercase;
  border-top:${props => props.border ? '1px solid #efefef' : 'none'};
}
`
const Info = styled.p`
&&
{
  font-size: 16px;
  color: ${props => props.color ? props.color : ' #282828'};
  cursor: ${props => props.cursor ? props.cursor : 'unset'};
  font-weight: ${props => props.fontweight ? props.fontweight : 'normal'};
}
&& span
{
  font-weight: bold;
  display:inline-block;
  width:200px;
}
`
const Username = styled.p`
&&
{
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  line-height: 149px;
  border-bottom: 1px solid #6b94bb;
}
`
const Action = styled.p`
&&
{
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.3;
}
`
const Links = styled.div`
&&
{
  position: absolute;
  bottom: 10px;
}
`
const Link = styled.a`
&&
{
  font-size: 16px;
  display: block;
  font-weight: 300;
  color: #fff;
  line-height: 2.5;
  cursor: pointer;
  text-decoration: none;
}
`
